import { safeJson } from "src/app/helpers/Index";
import React from "react";
import { Attendance, Fixture, Partner } from "src/app/interfaces/Index";
import { FixtureService, PartnerService } from "src/app/services/Index";
import "./ScoreboardPartners.css";

type Props = {};
type State = {
	currentPartner: Partner;
	currentIndex: number;
	partners: Partner[];
	additionalMinutes: number;
};
export class ScoreboardPartners extends React.Component<Props, State> {
	
	constructor(props: Props) {
		super(props);
		this.state = {currentPartner: new Partner, currentIndex: 0, partners: [], additionalMinutes: 0};
	}

	componentDidMount() {
		this.getPartners();		
		let loop = setInterval(() => this.setIndex(), 5000);
	}

	setIndex() {
		let index = this.state.currentIndex === this.state.partners.length - 1 ? 0 : this.state.currentIndex + 1;
		let currentItem = this.state.partners[index];
		this.setState({ currentIndex: index, currentPartner: currentItem });
	  }
	
	render() {
		return (
			<div id="scoreboard-wrapper-partner" style={{textAlign: "center", width:576, height:432}}>
				{this.renderTitle()}
				<div style={{width: 576, height:345, position:"absolute",marginLeft:-20}}>
				{<img src={this.getLogo()} className="imgLogo"/>}
				</div>
			</div>
		);
	}

	getLogo(){
		if(this.state.currentPartner.sponsor?.imagePartner !== undefined && this.state.currentPartner.sponsor?.imagePartner !== null) return this.state.currentPartner.sponsor?.imagePartner
		else return this.state.currentPartner.sponsor?.imageLight
	}

	async getPartners(){
		const res = await safeJson(PartnerService.getScoreboard());
		let arrays: Partner[];
		arrays = Array.isArray(res) ? res : [];
		if (res && res.error) {
		}
		// Nothing to rotate through — leave the board rather than blank it.
		if (!arrays.length) return;
		this.setState({partners: arrays, currentPartner: arrays[0]});
	}

	renderTitle(){
		if(this.state.currentPartner.partnerType?.length < 25)
		{
			return (
				<>
				<h1 style={{fontSize:40}}>{this.state.currentPartner.partnerType}</h1>
				</>
			)
		}
		else
		{
			return (
				<>
				<h1 style={{fontSize:25}}>{this.state.currentPartner.partnerType}</h1>
				</>
			)
		}
	}
}